import React, { useEffect, useState } from "react";
import RequestBuy from "../components/common/requestForm/RequestBuy";
import BestProducts from "../components/common/products/BestProducts";
import RequestGetList from "../components/common/requestForm/RequestGetList";
import { httpReauest } from "../utils/httpRequest";
import { useParams } from "react-router-dom";
import { CDN_BASE_URL } from "../config";
import { Helmet } from "react-helmet";

const BrandsDetailPage = () => {
  const { name } = useParams();

  const [loading, setLoading] = useState();

  const [brand, setBrand] = useState();
  const [category, setcategory] = useState();

  useEffect(() => {
    getData();
  }, [name]);

  async function getData() {
    setLoading(true);
    await httpReauest("GET", "/brand/" + name, {}, {}).then(({ data }) => {
      setBrand(data?.data);
    });
    setLoading(false);
  }

  return (
    <div className="container_1 py-8">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{"1924 -" + brand?.name}</title>
        <meta name="description" content={brand?.desc} />
        <meta name="keywords" content={""} />
        <meta name="og:description" content={brand?.desc} />
        <meta name="og:title" content={"1924 -" + brand?.name} />
      </Helmet>{" "}
      <div className="relative mb-12">
        <img
          src={CDN_BASE_URL + brand?.cover}
          className="w-full my-10 rounded-[10px] center"
          alt=""
        />
        <span className="absolute bg-white rounded-full w-[95px] h-[95px] -bottom-11 border-2 border-black left-[50%] translate-x-[-50%] overflow-hidden">
          <img
            className="w-full h-full object-cover rounded-full"
            alt="brand"
            src={CDN_BASE_URL + brand?.logo}
          />
        </span>
      </div>
      <div className="my-16">
        <h1 className="title">{brand?.title}</h1>
        <div
          className="desc_details overflow-x-scroll"
          dangerouslySetInnerHTML={{ __html: brand?.desc }}
        />
      </div>
      {/* <div className="my-12">
        {brand && <BestProducts brand={brand?._id} />}
      </div> */}
      <div className="pt-6">
        <RequestGetList />
      </div>
    </div>
  );
};

export default BrandsDetailPage;
